var map = {
	"./Chambers Europe_2022.jpg": 7617,
	"./Chambers-Global-2022.jpg": 9311,
	"./SEE-legal.jpg": 2160,
	"./best-lawyers.webp": 2602,
	"./chambers-europe.jpg": 7705,
	"./download-12.png": 2139,
	"./emea-top-tier-firms-2021.jpg": 8927,
	"./kp-3.jpg": 1859,
	"./wsg.jpg": 4357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1785;